export const RELOAD_SERVER_SETTINGS_FAILURE = 'RELOAD_SERVER_SETTINGS_FAILURE';

export const reloadServerSettingsFailure = ({ error, request }) => ({
    type: RELOAD_SERVER_SETTINGS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});